import axios from 'axios';
import { BASE_URL } from './inquiries';
import { fetchWithAuth } from './apiClient';

/**
 * 파트너.
 *
 * 공개 페이지는 문구와 파트너를 **한 번에** 받는다(`{ page, sections }`). 문구가 서버에
 * 있는 이유 — 네이버용 SSR 도 같은 응답으로 그리므로, 사람과 수집기가 같은 글을 본다.
 */
export const getPartnersPage = async () => (await axios.get(`${BASE_URL}/api/partners`)).data;

const ROOT = `${BASE_URL}/api/admin/cms/partners`;

const asJson = async (res, fallbackMessage) => {
    const text = await res.text();
    if (!res.ok) {
        let message = fallbackMessage;
        try {
            const body = JSON.parse(text);
            if (body?.message) message = Array.isArray(body.message) ? body.message.join('\n') : body.message;
        } catch {
            // JSON 이 아니면 기본 메시지를 쓴다
        }
        throw new Error(message);
    }
    return text ? JSON.parse(text) : {};
};

export const getAdminPartners = async () =>
    asJson(await fetchWithAuth(ROOT), '파트너 목록을 불러오지 못했습니다.');

export const createPartner = async (data) =>
    asJson(
        await fetchWithAuth(ROOT, { method: 'POST', body: JSON.stringify(data) }),
        '파트너를 추가하지 못했습니다.',
    );

export const updatePartner = async (id, data) =>
    asJson(
        await fetchWithAuth(`${ROOT}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
        '파트너를 저장하지 못했습니다.',
    );

export const deletePartner = async (id) =>
    asJson(await fetchWithAuth(`${ROOT}/${id}`, { method: 'DELETE' }), '파트너를 지우지 못했습니다.');

/**
 * 로고 업로드 → `/uploads/partners/…` 주소.
 * SVG 는 서버가 받지 않는다 — 같은 오리진에서 열리면 스크립트가 돌 수 있다. PNG·WebP 를 쓴다.
 */
export const uploadPartnerLogo = async (file) => {
    const body = new FormData();
    body.append('file', file);
    const data = await asJson(
        await fetchWithAuth(`${BASE_URL}/api/upload?folder=partners`, { method: 'POST', body }),
        '로고를 올리지 못했습니다. PNG·JPG·WebP 파일인지 확인해 주세요.',
    );
    return data.url;
};
